import { render, staticRenderFns } from "./RegistrationThankYou.vue?vue&type=template&id=3193c3c8"
import script from "./RegistrationThankYou.vue?vue&type=script&lang=js"
export * from "./RegistrationThankYou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports